/**
 * Settings card "رأس المال المستثمر" (C26 — D04 §5 "Capital add / withdraw", D-018, D-019, D-075, D-076, D-263):
 * binds `CapitalCardBody` (packages/ui, App.tsx:15415-15536) to the shared capital dialogs (`useCapitalActions`):
 * add / withdraw on the main IQD vault and the D-076 full-balance withdrawal of a chosen vault or box, each through the
 * gateway with the personal PIN. The card is shown to holders of `manage_capital` (D-263 (c); old guard
 * `invested_capital`, App.tsx:15416 — the card holds only actions).
 */
import { CapitalCardBody, SettingsCardFrame } from "@faylasuf/ui";
import { useCapitalActions } from "../capital/CapitalActions.js";

export function CapitalContainer({ customIcon, subSafesActive }: { customIcon?: string; subSafesActive: boolean }) {
  const capital = useCapitalActions(null, subSafesActive);
  return (
    <SettingsCardFrame cardKey="capital" {...(customIcon ? { customIcon } : {})}>
      <CapitalCardBody onAdd={capital.openAdd} onWithdraw={capital.openWithdraw} onFullBalance={capital.openFullBalance} />
      {capital.dialogs}
    </SettingsCardFrame>
  );
}
